import { Tooltip } from "antd";
import RightBarMethod from "../../../components/common/RightBar/RightBarMethod";

export const OwnersRightBar = [
  RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
    RightBarMethod("Move In Tenant", "1", "", "", "/people/tenants/move-in-tenant"),
    RightBarMethod("New Owner", "2", "", "", "/people/owners/new"),
    RightBarMethod("New Vendor", "3", "", "", "/people/vendors/new"),
    RightBarMethod("Owner ACH Setup", "4", "", "", "/people/owners/owner-ach"),
    RightBarMethod("Owner Portal Annoncement", "5", "", "", "/communication/letters_templates/owner-portal-announcement"),
    RightBarMethod("Send Owner Packets", "6", "", "", "/communication/letters_templates/send_owner_packets"),
    RightBarMethod("New Management Agreements", "7", "", "", "/management_agreement_documents/new"),
    RightBarMethod("Management Agreements", "8", "", "", "/generalsettings/management-agreement-templates"),

  ]),

  RightBarMethod(" LETTERS", "t2", <i className="fa-solid fa-file-lines"></i>, [
    RightBarMethod("Owner Statement (Enhanced)", "9", "", "", "/"),
    RightBarMethod("Owner Statement", "10", "", "", "/"),
  ]),
];

